import breakpoints from '@hm-group/fabric-tokens/breakpoints';
export const breakpointSizes = {
    xsmall: breakpoints.xsmall,
    small: breakpoints.small,
    medium: breakpoints.medium,
    large: breakpoints.large,
    xlarge: breakpoints.xlarge,
};
export var Breakpoints;
(function (Breakpoints) {
    Breakpoints["XLARGE"] = "xlarge";
    Breakpoints["LARGE"] = "large";
    Breakpoints["MEDIUM"] = "medium";
    Breakpoints["SMALL"] = "small";
    Breakpoints["XSMALL"] = "xsmall";
})(Breakpoints || (Breakpoints = {}));
//# sourceMappingURL=breakpoints.js.map